/**
 * THANH BEN TRANG = anh thu nho + CHON TRANG. Khong hon.
 *
 * =============================================================================
 *  VI SAO TEP NAY MONG DI
 * =============================================================================
 *  Truoc day day la noi giu trang thai chon VA phat moi lenh trang. Nguoi dung
 *  yeu cau dua "Xoay trái / Xoay phải / Xóa" va nhom "Trang" (chen trang trắng,
 *  tách, ghép, trích xuất) len THANH CONG CU TREN. Trang thai do gio song trong
 *  ui/usePageOps.ts, do App goi, va ca hai khung hinh cung doc mot ban.
 *
 *  Cai O LAI thanh ben la nhung gi chi co nghia canh anh thu nho:
 *    - chon theo khoang ("1-3, 7, 9-"), chon tat ca, bo chon;
 *    - cho biet dang chon nhung trang nao;
 *    - keo tha de sap xep lai;
 *    - canh bao mat mat sau thao tac trang, va buoc xac nhan khi ghep tep.
 *
 *  KHONG de lai nut cu nao o day. Hai nut "Xóa" o hai cho, mot cai o thanh
 *  cong cu mot cai o thanh ben, la hai duong toi cung mot lenh ma nguoi dung
 *  phai tu doan xem chung co giong nhau khong.
 */
import type { DocumentId, PdfCore } from '@pdfeditor/types';

import { Sidebar } from './Sidebar';
import { PageToolbar } from './PageToolbar';
import type { PageOps } from './usePageOps';
import type { ViewSlot } from '../viewer/planView';
import type { PlanDocuments } from '../viewer/usePlanDocuments';

export interface PagePanelProps {
  core: PdfCore | null;
  doc: DocumentId | null;
  /** So do DA PHAN GIAI - dung ham ma khung xem chinh dung. Xem planView.ts. */
  slots: readonly ViewSlot[];
  documents: PlanDocuments;
  /** Chi so O TRANG khung xem chinh dang o (khong phai chi so trang goc). */
  currentPage: number;
  fileName: string | null;
  onGoToPage: (pageIndex: number) => void;
  /** Trang thai va lenh trang - MOT ban duy nhat, dung chung voi thanh cong cu. */
  ops: PageOps;
}

export function PagePanel({
  core,
  slots,
  documents,
  currentPage,
  fileName,
  onGoToPage,
  ops,
}: PagePanelProps) {
  return (
    <Sidebar
      core={core}
      slots={slots}
      documents={documents}
      currentPage={currentPage}
      selected={ops.selected}
      onSelectSlot={ops.onSelectSlot}
      onGoToPage={onGoToPage}
      onReorder={ops.reorder}
      fileName={fileName}
      sourceLabel={ops.sourceLabel}
      toolbar={
        <PageToolbar
          selected={ops.selected}
          busy={ops.busy}
          mergePreview={ops.mergePreview}
          onConfirmMerge={ops.confirmMerge}
          onCancelMerge={ops.cancelMerge}
          warning={ops.warning}
          onDismissWarning={ops.dismissWarning}
        />
      }
    />
  );
}
